var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMytransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_1052)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248.945,
    cy: 250,
    r: 234.769,
    fill: "white",
    stroke: "white",
    strokeWidth: 30.4622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.18 95.1577H258.54C306.043 95.1577 344.553 133.667 344.553 181.171V363.856H140.18V95.1577Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.943 364.183C222.943 364.183 170.401 364.183 158.141 364.183C145.882 364.183 137.601 360.683 137.125 345.502C136.648 330.321 137.131 131.249 137.125 117.235C137.118 103.221 142.386 92.715 158.141 92.7153C173.897 92.7156 283.659 92.7153 283.659 92.7153M283.659 92.7153V149.928H344.374M283.659 92.7153L344.374 149.928M344.374 149.928V224.071",
    stroke: "black",
    strokeWidth: 15.2101,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.623 407.477C383.547 409.486 386.736 409.553 388.744 407.629C390.752 405.704 390.82 402.516 388.896 400.507L381.623 407.477ZM343.153 367.335L381.623 407.477L388.896 400.507L350.426 360.365L343.153 367.335Z",
    fill: "#4045A1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.929,
    cy: 304.75,
    r: 74.9104,
    fill: "#FEF4E8",
    stroke: "#4045A1",
    strokeWidth: 15.2101
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.336 141.28H232.895",
    stroke: "black",
    strokeWidth: 15.2101,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.352 185.065H232.911",
    stroke: "black",
    strokeWidth: 15.2101,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.305 262.077H327.92V270.461H303.161C303.161 270.461 311.033 279.181 311.033 284.882H327.847V292.595H311.748C311.748 292.595 308.528 318.619 277.688 317.01L315.326 359.468H300.3L262.305 318.486V309.9C262.305 309.9 280.981 310.436 289.924 304.736C297.151 300.108 296.221 297.29 296.865 294.607C297.08 293.601 296.292 292.663 295.219 292.663H262.305V284.949H296.007C296.721 284.949 297.151 284.278 296.794 283.674C295.362 281.059 291.57 275.223 286.347 274.15C279.549 272.809 262.305 272.473 262.305 272.473V262.077Z",
    fill: "#4045A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_1052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytransactions);
export default __webpack_public_path__ + "static/media/mytransactions.33681556b52f1df053f5680072390643.svg";
export { ForwardRef as ReactComponent };